<template>
    <custom-v-select
        v-model="prefill"
        :placeholder="$tc('models.prepaidcard')"
        label="_label"
        :options="store.getters.getSortedList('prepaidCards')"
        :is-column-filter="false"
    >
        <template #option="selected">
            <prepaid-card :model-value="selected" />
        </template>
    </custom-v-select>
</template>

<script>
import store from '@/store';

export default {
    props: {
        modelValue: Number,
    },
    computed: {
        prefill: {
            get () {
                return this.modelValue;
            },
            set (val) {
                this.$emit('update:modelValue', val);
            },
        },
        store () {
            return store;
        },
    },
};
</script>
